import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { langStats } from '../../data';
import { devices } from '../../data';
import { Device, DataForCharts } from './../../statistics.model'
import { StatisticsService } from '../../statistics.service'
import { SharedService } from '../../../../services/shared.service';
import { FirebaseService } from '../../../../service/firebase.service';
import { StatisticsComponent } from '../../statistics.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalTextInputComponent } from '../../../../modals/modal-text-input/modal-text-input.component';
import { ModalTabComponent } from '../../../../modals/modal-tab/modal-tab.component';

@Component({
  selector: 'app-global',
  templateUrl: './global.component.html',
  styleUrls: ['./global.component.scss']
})
export class GlobalComponent implements OnInit, OnDestroy {
  langStats: any[];
  multi: any[];

  devicesForCharts: DataForCharts[] = []
  devices: Device[] = []
  devicesStatus: Array<{ lastStatus: string, deviceName: string, configName: string, userId: string, deviceId: string, docIdDevice: string, docStatusId?:string }> = []
  selectedDevice: Device;
  _deviceFromRoute: Device;
  view: any[] = [700, 400];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;

  showXAxisLabel = true;
  xAxisLabel = "Nom de l'appareil";
  showYAxisLabel = true;
  yAxisLabel = 'Sessions utilisateurs';

  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'right';

  dataObservable: any;
  routeObservable: any;
  colorScheme = {
    domain: ['#122B47', '#3A5DE5', '#EE2E4F', '#FCBF00']
  };
  startDateRange: Date;
  endDateRange: Date;

  defaultStartDateRange: Date;
  defaultEndDateRange: Date;
  isInit: boolean = false;
  isLoading: boolean = true;
  public dialogRef = null;
  constructor(
    private router: Router,
    private service: StatisticsService,
    public _sharedVar: SharedService,
    private firebaseService: FirebaseService,
    private parentComponent: StatisticsComponent,
    private route: ActivatedRoute,
    private _dialog: MatDialog
  ) {


  }

  ngOnInit(): void {
    // Object.assign(this, { devices }),
    //  Object.assign(this, { langStats })


    console.log(this.devices)
    this.endDateRange = new Date();
    this.endDateRange.setHours(23, 59, 0, 0);

    this.startDateRange = new Date();
    this.startDateRange.setMonth(this.endDateRange.getMonth() - 1)
    this.startDateRange.setHours(0, 1, 0, 0);


    this.defaultStartDateRange = new Date(this.startDateRange.getTime());
    this.defaultEndDateRange = new Date(this.endDateRange.getTime());


    console.log(this.defaultStartDateRange, this.defaultEndDateRange)
    // remplacer la clé 'sessions' par 'value' pour ngx-chart
    console.log("GLBOAL")



    this.routeObservable = this.route.params
      .subscribe(
        (params: Params) => {
          this._deviceFromRoute = {
            name: this.route.snapshot.params['id']
          }
          this.onRouteSub();

        }
      );
    this.initStatusDevices();
  }


  initStatusDevices() {
    this.firebaseService.getDevicesStatus().onSnapshot(async docSnapshot => {
      //  this.devicesStatus = [];
      let data: any = docSnapshot.docs.map(v => {
        return { id: v.id, data: v.data() }
      });

      console.log(data)

      for (let v of data) {
        let item = v.data;

        item.docStatusId = v.id;
        item.print = await this.firebaseService.getPrintHistoryCounts(v.id)
        console.log(this.devicesStatus, )
        console.log(this.devicesStatus.find(d => d.docStatusId == v.id), v.id )
        if (this.devicesStatus.find(d => d.docStatusId == v.id))
        {
          this.devicesStatus[this.devicesStatus.findIndex(d => d.docStatusId == v.id)] = Object.assign(this.devicesStatus[this.devicesStatus.findIndex(d => d.docStatusId == v.id)], item)

        } else
          this.devicesStatus.push(item);
      }
      /* data.map(v => {
         let item = v.data;
 
         item.docStatusId = v.id;
 
         this.devicesStatus.push(item);
 
       })*/
      //      this.devicesStatus = data;


      await this.setDeviceIdentification();
      console.log("DEVICE STATUS", data, this.devicesStatus);
    })
  }

  updateDeviceStatus() {

  }

  async setDeviceIdentification() {
    for (let device of this.devicesStatus) {

      if (!device.deviceName || !device.docIdDevice) {
         let doc = await this.firebaseService.getDeviceInformations(device.deviceId)
      //  console.log(device.deviceId)
        //console.log(device, doc.docs[0]?.data())
        console.log(doc.docs[0])
      device.deviceName = doc.docs[0]?.data().borneName;
      device.docIdDevice = doc.docs[0]?.id
      }
     
    }
  }

  setDateRange() {
    this.endDateRange.setHours(23, 59, 0, 0);

    this.startDateRange.setHours(0, 1, 0, 0);

    console.log(this.startDateRange.getTime() == this.defaultStartDateRange.getTime(), this.endDateRange.getTime() == this.defaultEndDateRange.getTime())



    if (this.startDateRange != null && this.endDateRange != null && this.isInit &&
      (this.startDateRange.getTime() != this.defaultStartDateRange.getTime() || this.endDateRange.getTime() != this.defaultEndDateRange.getTime())) {
      // this.updateDateRangeDisplay();
      this.updateDate();

      this.defaultEndDateRange = new Date(this.endDateRange.getTime())
      this.defaultStartDateRange = new Date(this.startDateRange.getTime())
    }

  }

  updateDate() {
    this.isLoading = true;
    let tmp = [];
    this.devices.forEach(tmpItem => {
      let item = tmpItem as any;
      this.firebaseService.getDeviceStat(item.deviceName).then(d => {
        let id = d.docs.map(v => v.id)[0];
        let data = d.docs.map(v => v.data())[0];
        if (id != undefined)


          /* REPLACE WITH A VALUE IN DEVICE STAT WITH A CLOUD FUNCTION FOR OPTIMIZATION */
          this.firebaseService.getDeviceSessionStat(id, this.startDateRange, this.endDateRange).then(s => {
            let sessiondata = s.docs.map(doc => doc.data())
            tmp.push({ name: item.deviceName, value: sessiondata.length })
            this.devicesForCharts = tmp;
            this.devicesForCharts = [...this.devicesForCharts]
            this.isInit = true;
            this.isLoading = false;
          }).catch(err => {
            console.log(err);
          })


      })
    })
  }

  resetDate() {
    this.endDateRange = new Date();
    this.endDateRange.setHours(23, 59, 0, 0);

    this.startDateRange = new Date();
    this.startDateRange.setMonth(this.endDateRange.getMonth() - 1)
    this.startDateRange.setHours(0, 1, 0, 0);



    this.initData();

  }

  initData() {
    let tmp = [];
    this.isLoading = true;

    //  console.log(this.devices)
    this.dataObservable = this.service.deviceArray.subscribe(d => {
      this.devices = d;
      console.log(this.devices)
      this.devices.forEach(tmpItem => {
        let item = tmpItem as any;
        this.firebaseService.getDeviceStat(item.deviceName).then(d => {
          let id = d.docs.map(v => v.id)[0];
          let data = d.docs.map(v => v.data())[0];
          if (id != undefined)


            /* REPLACE WITH A VALUE IN DEVICE STAT WITH A CLOUD FUNCTION FOR OPTIMIZATION */
            this.firebaseService.getDeviceSessionStat(id, this.startDateRange, this.endDateRange).then(s => {
              let sessiondata = s.docs.map(doc => doc.data())
              tmp.push({ name: item.deviceName, value: sessiondata.length })
              this.devicesForCharts = tmp;
              this.devicesForCharts = [...this.devicesForCharts]
              this.isInit = true;
              this.isLoading = false;
            }).catch(err => {
              console.log(err);
            })


        })
      })

    })
  }

  ngOnDestroy() {
    console.log("DESTROY")
    this.dataObservable.unsubscribe();
    this.routeObservable.unsubscribe();
  }

  changeSelectedDevice(deviceName: string) {

    let _devices: Device[]

    _devices = this.devices.filter(
      device => device.name == deviceName
    )

    this.selectedDevice = _devices[0]

    // remplacer la clé 'sessions' par 'value' pour ngx-charts

    if (deviceName == 'global') {

      this.selectedDevice = null
      this.dataObservable.unsubscribe();
      this.routeObservable.unsubscribe();
      this.router.navigateByUrl('/statistics/global')
    }

    else {

      this.devicesForCharts.forEach(item => {
        if (item.name == deviceName)
          this.service.sessionStat = item.value;
      })
      this.parentComponent.setLastUpdateDate();
      this.dataObservable.unsubscribe();
      this.routeObservable.unsubscribe();
      this.router.navigateByUrl('/statistics/device/' + deviceName)
    }



  }


  onSelect(data): void {
    // console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    //console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    // console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }



  onRouteSub() {
    /* this._filteredDevice = users[0].groups[0].devices.filter (
       device => device.name == this.route.snapshot.params['id']
     )*/

    console.log("ROUTE SUB", this.dataObservable)

    this.initData();



  }

  editBorneName(device) {

    console.log(device)
    this.dialogRef = this._dialog.open(ModalTextInputComponent, {
      width: '30vw',
      height: '30vh',
      data: {
        title: "Veuillez entrer le nouveau nom d'affichage",
        value: device.borneName
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(result, device)
        this.firebaseService.editDeviceName(result, device.docIdDevice)

        this.devicesStatus.find(v => v.deviceId == device.deviceId).deviceName = result;
        // device.borneName = result

      }
      console.log(result)
    })
    //console.log(device)
  }

  showHistory(device) {
    this.dialogRef = this._dialog.open(ModalTabComponent, {
      width: '26.75rem',
      height: '28.813rem',
      data: {
        device: device
      }
    })
  }
}
